import moment from "moment-timezone";

export const retention = {
  default: moment.duration(100, "days"),
  connections: moment.duration(7, "days"),
  logs: moment.duration(7, "days"),
};
